// cycleChangesSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  cycleChanges: {
    isLoading: false,
    data: null,
    errors: '',
    message: ''
  },
  saveCycleChanges: {
    isSaving: false,
    errors: '',
    successMessage: ''
  }
};

export const cycleChangesSlice = createSlice({
  name: 'SaveCycleChanges',
  initialState,
  reducers: {
    getCurrentcycleChangesRequest: (state) => {
      state.cycleChanges.isLoading = true;
      state.cycleChanges.errors = '';
      state.cycleChanges.message = '';
    },
    getCurrentcycleChangesSuccess: (state, action) => {
      state.cycleChanges.isLoading = false;
      state.cycleChanges.data = action.payload;
      state.cycleChanges.errors = '';
    },
    getCurrentcycleChangesFailure: (state, action) => {
      state.cycleChanges.isLoading = false;
      state.cycleChanges.errors = action.payload;
    },
    saveCycleChangesRequest: (state) => {
      state.saveCycleChanges.isSaving = true;
      state.saveCycleChanges.errors = '';
      state.saveCycleChanges.successMessage = '';
    },
    saveCycleChangesSuccess: (state, action) => {
      state.saveCycleChanges.isSaving = false;
      state.saveCycleChanges.successMessage = action.payload;
      state.saveCycleChanges.errors = '';
    },
    saveCycleChangesFailure: (state, action) => {
        console.log('action', action)
      state.saveCycleChanges.isSaving = false;
      state.saveCycleChanges.errors = action.payload;
    }
  }
});

export const {
  getCurrentcycleChangesRequest,
  getCurrentcycleChangesSuccess,
  getCurrentcycleChangesFailure,
  saveCycleChangesRequest,
  saveCycleChangesSuccess,
  saveCycleChangesFailure
} = cycleChangesSlice.actions;

export default cycleChangesSlice.reducer;
